__turbopack_context__.v({
  "button__icon": "QLJZLa_button__icon",
});
